<template>
    <div class="w-5/6 md:w-1/2 bg-white m-auto p-4 text-center rounded-xs shadow-md">
        <h1 class="text-lg text-cavilam-primary font-semibold mb-4">{{ title }}</h1>
        <p>{{ description }}</p>
    </div>
</template>

<script>
import App from "@/Layouts/App";

export default {

    layout: App,
    name: "Error",
    props: {
        status: Number,
        titre: String,
        texte: String,
    },
    computed: {
        title() {
            return this.titre[this.status]
        },
        description() {
            return this.texte[this.status]
        },
    },
}
</script>

<style scoped>

</style>
